import axios, { AxiosRequestConfig } from "axios";
import { errorInterceptor } from "./index";

const $authHost = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const authInterceptor = (config: AxiosRequestConfig) => {
  config.headers!.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;
  return config;
};

$authHost.interceptors.request.use(authInterceptor);
$authHost.interceptors.response.use(undefined, errorInterceptor);

export default $authHost;
